import { useObserver } from "mobx-react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { useStores } from "../../../store";
import { useState } from "react";
import Loader from "../../reusble_components/loader";
import { ResumeUploader } from "./Resume";
import { uploadFileToAzure } from "../../../services/azure";
import { pdfjs } from "react-pdf";
import axios from "axios";
import { apiGet, apiPostPut } from "../../../api/api_methods";
import { useParams } from "react-router-dom";

export default function AddResumes({ id }) {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

  const [fileName, setFileName] = useState([]);
  const { PopupStore, RecuiterStore, UserStore } = useStores();
  const [count, setCount] = useState(0);
  const [Upload, setUpload] = useState(false);
  // const { id } = useParams();
  // console.log(id);   // Get id from URL params

  const closeThisPopUP = () => {
    PopupStore.setAddResumes(false);
  };

  const fetchData = async (pdfFile) => {
    try {
      const response = await axios.get(pdfFile, {
        responseType: "arraybuffer",
      });

      const pdfData = response.data;

      const pdf = await pdfjs.getDocument({ data: pdfData }).promise;
      let fullText = "";

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const content = await page.getTextContent();
        const pageText = content.items.map((item) => item.str).join("\n");
        fullText += pageText + "\n";
      }
      console.log(fullText);
      return fullText;
    } catch (error) {
      console.error("Error fetching or parsing PDF file", error);
    }
  };

  const handledrag = async (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;

    if (!files || files.length === 0) {
      console.error("No files detected.");
      return;
    }

    try {
      const filesArray = Array.from(files);

      const newFileNames = await Promise.all(
        filesArray.map(async (file) => {
          if (!file || file.size === 0) {
            console.error(`File ${file.name} is not accessible or empty.`);
            return null; // Skip inaccessible or empty files
          }

          if (!file.name.endsWith(".pdf") || file.size < 100) {
            console.error(`${file.name} is not a valid PDF or is too small.`);
            return null; // Skip non-PDF files or very small files
          }

          const reader = new FileReader();

          return new Promise((resolve, reject) => {
            reader.onload = async () => {
              try {
                const pdfData = new Uint8Array(reader.result);
                const pdf = await pdfjs.getDocument({ data: pdfData }).promise;
                const numPages = pdf.numPages;
                console.log(`Number of pages in ${file.name}: ${numPages}`);
                resolve({ file, numPages });
              } catch (pdfError) {
                console.error(
                  `Error processing PDF ${file.name}:`,
                  pdfError.message
                );
                resolve({ file, numPages: 0 }); // Optionally resolve with numPages: 0
              }
            };

            reader.onerror = () => {
              console.error(`Error reading file ${file.name}:`, reader.error);
              reject(reader.error);
            };

            reader.readAsArrayBuffer(file);
          });
        })
      );

      // Filter out any null results from skipped files
      const validFileNames = newFileNames.filter((result) => result !== null);
      setFileName((prevFileNames) => [...prevFileNames, ...validFileNames]);
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };
  const handleFileChange = async (e) => {
    try {
      const timestamp = Date.now().toString();
      const min = 1000;
      const max = 9999;
      const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
      // const filesArray = Array.from(e.target.files);
      // const newFileNames = filesArray.map((file) => file);
      // setFileName((prevFileNames) => [...prevFileNames, ...newFileNames]);
      const filesArray = Array.from(e.target.files);
      const newFileNames = await Promise.all(
        filesArray.map(async (file) => {
          const reader = new FileReader();
          reader.readAsArrayBuffer(file);
          return new Promise((resolve, reject) => {
            reader.onload = async () => {
              const pdfData = new Uint8Array(reader.result);
              const pdf = await pdfjs.getDocument({ data: pdfData }).promise;
              const numPages = pdf.numPages;
              console.log(`Number of pages in ${file.name}: ${numPages}`);
              resolve({ file, numPages });
            };
            reader.onerror = (error) => reject(error);
          });
        })
      );
      setFileName((prevFileNames) => [...prevFileNames, ...newFileNames]);
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const handleSubmit = async () => {
    try {
      setUpload(true);

      let resumefiles = [];
      const userCoins = JSON.parse(localStorage.getItem("user"))?.coins || 0;

      if (fileName.length * 5 > userCoins) {
        setUpload(false);
        PopupStore.setMessage(
          userCoins >= 5
            ? `You can upload only ${userCoins / 5} resumes`
            : "You don't have enough credits to check the resumes score"
        );
        PopupStore.setAlert(true);
        return;
      }

      PopupStore.setAddResumes(false);

      RecuiterStore.setResumeCount(0);

      // Upload files and prepare resumefiles
      for (const file of fileName) {
        const timestamp = Date.now().toString();
        const randomNumber =
          Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000;
        const filenames = randomNumber + timestamp + file.name;

        const fileUploaded = await uploadFileToAzure(filenames, file.file, {
          action: "resume",
        });
        const text = await fetchData(fileUploaded.url);

        const body = {
          link: fileUploaded.url,
          content: text,
        };

        resumefiles.push(body);
        // setFile((prev) => [...prev, body]);
        setCount(count + 1);
        RecuiterStore.setResumeCount(Number(RecuiterStore.resumeCount) + 1);
      }

      // Create JD and resume info
      const body = {
        createdBy: JSON.parse(localStorage.getItem("user"))?._id,
        // model: 3,
        model: 1,
        jd: RecuiterStore.generatedJD,
        resumes: [], // Initialize with empty array
      };

      if (RecuiterStore?.generateParams?.title) {
        body.name = RecuiterStore?.generateParams?.title;
      }

      //   const res = await apiPostPut(
      //     body,
      //     "/jds/create-jd-and-resumeinfo",
      //     "POST"
      //   );

      //   if (res.status === 200) {
      RecuiterStore.setJDID(id);
      //set jdid to local storage
      localStorage.setItem("jdId", id);
      UserStore.getUserDetails(true);

      // Batch upload resumes in chunks of 20
      const chunkSize = 20;
      let totalResumesUploaded = 0;

      for (let i = 0; i < resumefiles.length; i += chunkSize) {
        const chunk = resumefiles.slice(i, i + chunkSize);
        const chunkBody = { resumes: chunk, isSave: "true" };

        // alert(id);

        const chunkRes = await apiPostPut(
          chunkBody,
          `/resumeScores/create-resumeScore/${id}`,
          "POST"
        );

        if (chunkRes.status !== 200) {
          alert(chunkRes.body?.message);
          break; // Stop if there's an error in uploading a chunk
        }

        totalResumesUploaded += chunk.length;

        // Optional: Add a delay between batches if needed
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }

      // const response = await apiPostPut(
      //   {},
      //   `/resumeScores/create-resumeScore/${id}`,
      //   "POST"
      // );

      // if (response.status === 200) {
        // Show Timer Component Here
        PopupStore.setAddResumes(false);
        // showTimerComponent();
        RecuiterStore.loader = true;
        RecuiterStore.fetchResumeScore(0, RecuiterStore.jdId, 10);
        RecuiterStore.fetchjd();
      // } else {
      //   PopupStore.setMessage(
      //     userCoins >= 5
      //       ? `You can upload only ${userCoins / 5} resumes`
      //       : "You don't have enough credits to check the resumes score"
      //   );
      //   PopupStore.setAddResumes(false);
      //   alert(response.body?.message);
      // }
      setFileName([]);
      //   } else {
      //     alert(res.body?.message);
      //   }

      setUpload(false);
    } catch (error) {
      setUpload(false);
      console.error("Error uploading file:", error);
      PopupStore.setAddResumes(false);
    }
  };

  const showTimerComponent = () => {
    let remainingTime = fileName.length >= 10 ? 60 : 10;

    const timerInterval = setInterval(() => {
      if (remainingTime > 0) {
        PopupStore.setMessage(
          `Sorting your Resumes. Please wait... ${remainingTime} seconds remaining.`
        );
        PopupStore.setAlert(true);
        remainingTime -= 1;
      } else {
        clearInterval(timerInterval);
        PopupStore.setAlert(false);
        RecuiterStore.fetchResumeScore(0, RecuiterStore.jdId, 10);
        RecuiterStore.fetchjd();
        // setTimeout(() => {
        //   scrollToBottom();
        // }, 2000);
      }
    }, 1000);
  };

  return useObserver(() => {
    return (
      <>
        <Loader loader={Upload} text={"Adding your Resumes. Please wait..."} />
        {PopupStore.addResumes && (
          <div
            onClick={() => closeThisPopUP}
            className="fixed w-screen h-screen z-20 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40"
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="absolute  inset-0 bg-bg3 z-20 flex flex-col justify-center rounded-3xl items-center md:w-[75%] lg:w-[80%] w-[90%] h-[75%] md:h-[80%] lg:h-[80
              %] m-auto overflow-y-auto no-scrollbar"
            >
              <div className="flex flex-col gap-6 justify-center my-auto items-center p-6   h-full py-5 w-[100%] md:w-[100%] lg:[100%]  rounded-xl overflow-y-auto">
                <AiOutlineCloseCircle
                  className="absolute text-xl cursor-pointer  top-2 right-2"
                  onClick={closeThisPopUP}
                />
                <div className="w-full">
                  <ResumeUploader
                    fileName={fileName}
                    setFileName={setFileName}
                    handleFileChange={handleFileChange}
                    handledrag={handledrag}
                    handleSubmit={handleSubmit}
                    addedResumes={true}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  });
}
